<script setup>
import { computed } from 'vue';
import Modal from '@/Components/Modal.vue';
import { HERA_CASSETTE_LABEL_MAX } from '@/themes/Hera/composables/useHeraCassetteLabelPrinting';

const props = defineProps({
    show: { type: Boolean, default: false },
    count: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    maxLabels: { type: Number, default: HERA_CASSETTE_LABEL_MAX },
});

const emit = defineEmits(['close', 'confirm']);
const exceedsLimit = computed(() => props.count > props.maxLabels);
const canSubmit = computed(() => props.count > 0 && !exceedsLimit.value && !props.loading);
const countLabel = computed(() => props.count === 1 ? '1 etichetta' : `${props.count} etichette`);

const close = () => {
    if (!props.loading) emit('close');
};
</script>

<template>
    <Modal :show="show" max-width="md" :closeable="!loading" @close="close">
        <form class="p-5 md:p-6" @submit.prevent="emit('confirm')">
            <h2 class="text-lg font-bold text-principal">Genera etichette PDF</h2>
            <p class="mt-3 text-sm text-gray-700">
                Verrà preparato un unico PDF con <strong>{{ countLabel }}</strong>.
                Riceverai una notifica quando sarà pronto.
            </p>
            <p v-if="exceedsLimit" class="mt-4 border-l-4 border-red-600 bg-red-50 px-3 py-2 text-sm text-red-800"
                role="alert">
                Il limite è {{ maxLabels }} etichette. Restringi la selezione o i filtri.
            </p>
            <div class="mt-6 flex justify-end gap-2">
                <button type="button" class="h-11 rounded-md border border-gray-300 bg-white px-4 text-sm font-semibold"
                    :disabled="loading" @click="close">
                    Chiudi
                </button>
                <button type="submit"
                    class="h-11 rounded-md bg-[var(--color-hc)] px-5 text-sm font-bold text-white disabled:cursor-not-allowed disabled:opacity-40"
                    :disabled="!canSubmit" :aria-busy="loading">
                    {{ loading ? 'Generazione...' : 'Genera PDF' }}
                </button>
            </div>
        </form>
    </Modal>
</template>